// extracted by mini-css-extract-plugin
export default {"root":"CustomDateInput_root__3Gk-v","input":"CustomDateInput_input__ZyyAX"};